import * as React from 'react';
import classNames from 'classnames';
import {getVariantClass, getBooleanVariants} from '../../utilities';

export type ButtonSkinType = 'teal' | 'salmon' | 'lowlight' | 'light' | 'reset';

type AnchorElementProps = JSX.IntrinsicElements['a'];
type ButtonElementProps = JSX.IntrinsicElements['button'];
type ComposedProps = AnchorElementProps & ButtonElementProps;

export interface ButtonProps extends ComposedProps {
  small?: boolean;
  secondary?: boolean;
  block?: boolean;
  skin?: ButtonSkinType;
  href?: string;
  text?: string;
}

const BASE_CLASS = 'marketing-button';
const SKIN_PREFIX = 'skin';

function getSkinClassName(skin) {
  if (!skin) {
    return '';
  }
  return getVariantClass(BASE_CLASS, skin, SKIN_PREFIX);
}

export function Button({
  text = '',
  href = '',
  skin = '',
  small = false,
  block = false,
  children,
  secondary = false,
  className = '',
  ...restProps
} : ButtonProps) {
  const buttonProps: any = {
    children,
    className: classNames(
      className,
      BASE_CLASS,
      getSkinClassName(skin),
      getBooleanVariants(BASE_CLASS, {small, block, secondary}),
    ),
    ...restProps,
  };

  if (href) {
    buttonProps.href = href;
  }

  return React.createElement(
    href ? 'a' : 'button',
    buttonProps,
    text || children,
  );
}

export default Button;
